import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import throttle from 'lodash/throttle';

import * as types from './types';

const syncPersonTypes = (force = false) => {
  return (dispatch, getState, {persons}) => {
    const locale = getState()?.localization?.locale;

    if (force || getState()?.personTypes?.locale !== locale || isEmpty(getState()?.personTypes?.list)) {
      dispatch({type: types.PERSON_TYPES_REQUEST});

      return persons
        .getPersonTypes(locale)
        .then((results) =>
          dispatch({
            type: types.PERSON_TYPES_SUCCESS,
            payload: {
              data: results?.data?.persons,
              locale,
            },
          }),
        )
        .catch((error) =>
          dispatch({
            type: types.PERSON_TYPES_FAILURE,
            error,
          }),
        );
    }
  };
};

const _throttledSyncPersonTypes = throttle((dispatch, force) => dispatch(syncPersonTypes(force)), 10000);

export const getPersonTypes = (force) => {
  return (dispatch) => {
    return _throttledSyncPersonTypes(dispatch, force);
  };
};

export const getPersonTypesDict = (clientId, force) => {
  return (dispatch, getState, {persons}) => {
    const locale = getState()?.localization?.locale;

    const notInDictionary = isNil(getState()?.personTypes?.personTypesDict?.[clientId]?.[locale]);

    if (force || notInDictionary) {
      dispatch({type: types.PERSON_TYPES_DICT_REQUEST});

      return persons
        .getPersonCustomTypes({params: {locale, organizationId: clientId, includeRoot: true}})
        .then((response) => {
          const rawResults = response?.data;
          let results;
          if (!rawResults?.personTypes) {
            results = null;
          } else {
            results = rawResults.personTypes.map((pt) => ({
              id: pt.id,
              name: pt.nameTranslated || pt.name,
              standard: pt.standard || false,
              numberOfAssociatedPeople: pt.numberOfAssociatedPeople || 0,
              readOnly: pt.readOnly || false,
            }));
          }
          return dispatch({
            type: types.PERSON_TYPES_DICT_SUCCESS,
            payload: {
              list: results,
              locale,
              clientId,
            },
          });
        })
        .catch((error) =>
          dispatch({
            type: types.PERSON_TYPES_DICT_FAILURE,
            error,
          }),
        );
    }

    return Promise.resolve();
  };
};
